import { render, staticRenderFns } from "./riskOperationControl.vue?vue&type=template&id=0ddf885a&scoped=true"
import script from "./riskOperationControl.vue?vue&type=script&lang=js"
export * from "./riskOperationControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddf885a",
  null
  
)

export default component.exports